import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {
    fields: {
        [fields.textFieldValue]: string;
        [fields.multilineTextFieldValue]: string;
        [fields.imagePickerFieldValue]: any;
    };
}

const enum fields {
    textFieldValue = "textFieldValue",
    multilineTextFieldValue = "multilineTextFieldValue",
    imagePickerFieldValue = "imagePickerFieldValue",
}

export interface ImageContentwithHoverEffectStyles {
    image?: LazyImageProps;

    container?: InjectableCss;
    container1?: InjectableCss;
    container2?: InjectableCss;
    BannerImg?: InjectableCss;
    Img?: InjectableCss;
    btn?: InjectableCss;
    headeingSaveOn?: InjectableCss;
}

const imageContentwithHoverEffectStyles: ImageContentwithHoverEffectStyles = {
    container: {
        css: css`
            text-align: center;
            padding: 0px;
        `,
    },

    image: {
        css: css`
            width: 100%;
        `,
    },
    container1: {
        css: css`
            display: none;
            z-index: 5;
            text-align: left;
            position: absolute;
            top: 0;
            padding: 20px;
            color: #fff;
            font-weight: 600;
            height: 100%;
            background: rgb(216 62 62 / 80%);
            transition: 1.3s;
            background-blend-mode: multiply;
            width: 100%;
        `,
    },

    container2: {
        css: css`
            //height:650px;
            //display:none;
            border: 1px solid #e6e6e6;
            padding: 10px;
            margin: 0px;
            box-shadow: 0 2px 4px #e4e4ed;
        `,
    },
    headeingSaveOn: {
        css: css`
            font-size: 28px;
            font-weight: bold;
        `,
    },
    Img: {
        css: css`
            position: relative;
            &:hover {
                div {
                    display: block;
                }
                button {
                    display: block;
                }
            }
            img {
                width: 100%;
            }
        `,
    },
    btn: {
        css: css`
            // position: absolute;
            // top: 62%;
            // left: 5%;
            // z-index: 100;
            display: none;
            margin-top: 25px;
        `,
    },
};

const ImageContentwithHoverEffect: React.FC<Props> = props => {
    return (
        <>
            <StyledWrapper {...imageContentwithHoverEffectStyles.container2}>
                <StyledWrapper {...imageContentwithHoverEffectStyles.container}>
                    {/* <StyledWrapper {...ImageContentwithHoverEffectStyles.headeingSaveOn}>
                            {props.fields.textFieldValue}
                        </StyledWrapper> */}

                    <StyledWrapper {...imageContentwithHoverEffectStyles.Img}>
                        <LazyImage
                            src={props.fields.imagePickerFieldValue}
                            altText={translate("home")}
                            {...imageContentwithHoverEffectStyles.image}
                        />
                        <StyledWrapper {...imageContentwithHoverEffectStyles.container1}>
                            {props.fields.multilineTextFieldValue}
                            <StyledWrapper {...imageContentwithHoverEffectStyles.btn}>
                                <Link href="/cart">
                                    <Button>Read More</Button>
                                </Link>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        // {
        //     name: fields.textFieldValue,
        //     displayName: "Text",
        //     editorTemplate: "TextField",
        //     defaultValue: "",
        //     fieldType: "General",
        //     tooltip: "text tip",
        //     placeholder: "text placeholder",
        //     isRequired: true,
        // },
        {
            name: fields.multilineTextFieldValue,
            displayName: "MultilineText",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "multi line tip",
            placeholder: "multi line placeholder",
            isRequired: true,
        },
        {
            name: fields.imagePickerFieldValue,
            displayName: "File",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            isRequired: true,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ImageContentwithHoverEffect,
    definition,
};

export default widgetModule;
